// extracted by mini-css-extract-plugin
module.exports = {"container":"TransitionStripe_container__3Fygc","banner":"TransitionStripe_banner__7pLwr","transitionTitle":"TransitionStripe_transitionTitle__3GGxo"};